import { Grid, withStyles } from "@material-ui/core";
import React from "react";
import styles from "../styles";

function Detail({ classes, title, value }) {
  return (
    <Grid container className={classes.infoRow}>
      <Grid item xs={5} className={classes.infoTitle}>
        {title}
      </Grid>
      <Grid item xs={7} className={classes.infoValue}>
        {value ? value : ""}
      </Grid>
    </Grid>
  );
}

export default withStyles(styles)(Detail);
